import { Button } from "components/ui/button";
import { Spinner } from "components/ui/spinner";
import { Modal } from "components/ui/modal";
import useMqttApi from "hooks/use-mqtt-api";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { RequestTopics } from "services/topics";

export const RebootDeviceModal = ({ show, onClose }) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "settings.general_settings.reboot_device.modal",
  });

  const { fetch: rebootDevice, loading } = useMqttApi({
    requestTopic: RequestTopics.RebootDevice,
    enabled: false,
    onError: (error) => {
      toast.error(error.message);
      onClose();
    },
    onSuccess: () => {
      toast.success(t("success_message"));
      onClose();
    },
  });

  return (
    <Modal title={t("title")} show={show} onClose={onClose}>
      <p className="text-base mb-4 max-w-sm">{t("description")}</p>
      <span className="flex flex-col-reverse sm:flex-row">
        <Button
          onClick={onClose}
          className="flex-1 mt-2 sm:mt-0 sm:mr-3"
          variant="secondary"
        >
          {t("cancel_button")}
        </Button>
        <Button
          className="flex-1"
          onClick={() => rebootDevice()}
          disabled={loading}
        >
          {loading ? <Spinner className="size-5 mr-3" /> : null}
          {t("confirm_button")}
        </Button>
      </span>
    </Modal>
  );
};
